module.exports = __webpack_public_path__ + "static/media/DSCF0252-SbsoiYgs.ffe51449.JPG";